// Site-wide SEO fallbacks and constants.
//
// SITE_URL note: public/.htaccess force-redirects every request to the
// non-www host (`RewriteRule ^ https://travellerchoiceladakh.com%{REQUEST_URI}`),
// and both public/robots.txt and public/sitemap.xml already reference the
// non-www host. src/App.js previously used the `www` subdomain for its
// canonical tag, which conflicted with those three files. Non-www is used
// here to match the host the site actually serves production traffic on.
export const SITE_NAME = "Traveller Choice Ladakh";
export const SITE_URL = "https://travellerchoiceladakh.com";

// Mirrors the static fallback content already in public/index.html so the
// pre-hydration HTML and the post-hydration Helmet output never disagree.
export const DEFAULT_TITLE =
  "Traveller Choice Ladakh - Ladakh Tourism, Plan your Leh Ladak trip now.";
export const DEFAULT_DESCRIPTION =
  "Traveller Choice Ladakh offers a one-stop destination for all your travel needs in Leh Ladakh.";

// Existing logo already deployed at the site root by CRA's public/ folder.
export const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

export const CONTACT_PHONE = "+91 9149516495";

// Real, currently-published social profiles (see share links in
// PackageDestination.jsx). The LinkedIn link found in that same file
// ("in/your-linkedin-url") is a placeholder, not a real profile, so it is
// deliberately left out of structured data.
export const SOCIAL_LINKS = [
  "https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL",
  "https://www.instagram.com/travellers_choice_ladakh/",
];
